import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { AppRoutingModule } from './app-routing.module';
import { JwtInterceptor, ErrorInterceptor } from './_helpers';
import { AppComponent } from './app.component';
import { AlertComponent } from './_components';
import { DatePipe } from '@angular/common';
import { NgxSpinnerModule } from "ngx-spinner";;
import { NgIdleKeepaliveModule } from '@ng-idle/keepalive';



;
@NgModule({
    imports: [
        NgIdleKeepaliveModule.forRoot(),
        BrowserModule,
        ReactiveFormsModule,
        HttpClientModule,
        NgxSpinnerModule,
        AppRoutingModule
    ],
    declarations: [
        AppComponent,
        AlertComponent        
    ],
    providers: [DatePipe,
        { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    ],
    bootstrap: [AppComponent],
    exports:[]
})
export class AppModule { };